module.exports = __webpack_public_path__ + "static/media/view age wise.79c1ee89.svg";